import React from 'react';
import AddToCart from '@jetshop/core/components/Mutation/AddToCart';
import t from '@jetshop/intl';
import { toast } from 'react-toastify';
import styled from 'react-emotion';
import UIButton from '../../ui/Button';
import ProductToast from './ProductToast';
import CartQuery from '../../Cart/CartQuery.gql';
import { ReactComponent as CartSVG } from '../../../svg/Cart.svg';

const Button = styled(UIButton)`
  background: ${({ theme }) => theme.colors.themeGreen};
  transition: background ease-in-out 0.2s;
  &:hover {
    background: ${({ theme }) => theme.colors.themeGreenLight};
  }
`;

const Cart = styled(CartSVG)`
  margin-left: 2.5rem;
  fill #fff;
  ${({ theme }) => theme.below.md} {
    margin-left: 1.5rem;
  }
`;

export default ({ product, quantity = 1, inStock }) => {
  return (
    <AddToCart
      cartQuery={CartQuery}
      onAddToCart={selectedVariation =>
        toast(
          <ProductToast
            selectedVariation={selectedVariation}
            product={product}
          />,
          {
            autoClose: 2000
          }
        )
      }
    >
      {(addToCart, missingOption, hasMissingOption) => (
        <Button
          disabled={hasMissingOption || !inStock}
          css={(hasMissingOption || !inStock) && { opacity: 0.5 }}
          onClick={() => addToCart(product, quantity)}
          data-testid="add-to-cart"
        >
          {missingOption
            ? t('Please select {option}', { option: missingOption.name })
            : t('Add to cart')}
          <Cart />
        </Button>
      )}
    </AddToCart>
  );
};
